import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @namespace Constants
 * @desc App constants
 */

/**
 * @constant {Object} ActionTypes
 * @memberof Constants
 */
export const ActionTypes = keyMirror({
  USER_LOGIN_REQUEST: undefined,
  USER_LOGIN_SUCCESS: undefined,
  USER_LOGIN_FAILURE: undefined,
  USER_GOOGLE_LOGIN_REQUEST: undefined,
  USER_GOOGLE_LOGIN_SUCCESS: undefined,
  USER_GOOGLE_LOGIN_FAILURE: undefined,
  USER_UNVERIFY_TOKEN_REQUEST: undefined,
  USER_UNVERIFY_TOKEN_SUCCESS: undefined,
  USER_UNVERIFY_TOKEN_FAILURE: undefined,
  USER_VERIFY_TOKEN_REQUEST: undefined,
  USER_VERIFY_TOKEN_SUCCESS: undefined,
  USER_VERIFY_TOKEN_FAILURE: undefined,
  USER_LOGOUT_REQUEST: undefined,
  USER_LOGOUT_SUCCESS: undefined,
  USER_LOGOUT_FAILURE: undefined,
  REDIRECT_LOGGED_USER: undefined,
  UPDATE_BREADCRUMBS: undefined,
  UPDATE_INTERFACE_LANGUAGE: undefined,
  UPDATE_INTERFACE_USER_TIMEZONE: undefined,
  TOGGLE_TOPFLAG_ANIMATION_OFF: undefined,
  TOGGLE_TOPFLAG_ANIMATION_ON: undefined,
  UPLOAD_FILE_REQUEST: undefined,
  UPLOAD_FILE_UPDATE_PROGRESS: undefined,
  UPLOAD_FILE_SUCCESS: undefined,
  UPLOAD_FILE_CANCEL: undefined,
  UPLOAD_FILE_FAILURE: undefined,
  SHOW_ALERT: undefined,
  HIDE_ALERT: undefined,
});

export const ApiServer = process.env.VITE_API_URL || process.env.API_URL;
export const BatchApiServer = process.env.VITE_API_URL || process.env.BATCH_API_URL;
export const AppleLoginRedirect = process.env.APPLE_LOGIN_REDIRECT;
export const AppleRegisterRedirect = process.env.APPLE_REGISTER_REDIRECT;
export const AppleAddEmailRedirect = process.env.APPLE_ADD_EMAIL_REDIRECT;
export const FacebookLoginRedirect = process.env.FACEBOOK_LOGIN_REDIRECT;
export const FacebookRegisterRedirect = process.env.FACEBOOK_REGISTER_REDIRECT;
export const FacebookAddEmailRedirect = process.env.FACEBOOK_ADD_EMAIL_REDIRECT;
export const GoogleLoginRedirect = process.env.GOOGLE_LOGIN_REDIRECT;
export const GoogleRegisterRedirect = process.env.GOOGLE_REGISTER_REDIRECT;
export const GoogleAddEmailRedirect = process.env.GOOGLE_ADD_EMAIL_REDIRECT;
export const MicrosoftLoginRedirect = process.env.MICROSOFT_LOGIN_REDIRECT;
export const MicrosoftRegisterRedirect = process.env.MICROSOFT_REGISTER_REDIRECT;
export const MicrosoftAddEmailRedirect = process.env.MICROSOFT_ADD_EMAIL_REDIRECT;
